module.exports = __webpack_public_path__ + "img/settings.dff20655.svg";